<p-dialog
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '32rem', maxWidth: '94vw'}"
  [header]="'provider.questionnaire.templateFill.dialog.header' | transloco"
  data-testid="template-fill-dialog"
>
  @if (visible()) {
    <div class="flex flex-col gap-4">
      <p data-testid="template-fill-dialog-message">
        @if (summary().fillableCount > 0) {
          {{
            'provider.questionnaire.templateFill.dialog.message'
              | transloco: {count: summary().fillableCount}
          }}
        } @else {
          {{ 'provider.questionnaire.templateFill.dialog.nothingOpen' | transloco }}
        }
      </p>

      @if (summary().answeredCount > 0) {
        <div class="flex items-start gap-3">
          <p-checkbox
            [binary]="true"
            [ngModel]="overwriteAnswered()"
            (ngModelChange)="overwriteAnswered.set($event)"
            inputId="templateFillOverwrite"
            data-testid="template-fill-overwrite"
          />
          <label for="templateFillOverwrite" class="text-sm cursor-pointer">
            {{
              'provider.questionnaire.templateFill.dialog.overwrite'
                | transloco: {count: summary().answeredCount}
            }}
          </label>
        </div>
      }

      <div class="flex justify-end gap-2">
        <p-button
          [label]="'common.cancel' | transloco"
          severity="secondary"
          (onClick)="onVisibleChange(false)"
          data-testid="template-fill-cancel"
        />
        <p-button
          [label]="'provider.questionnaire.templateFill.dialog.confirm' | transloco"
          icon="pi pi-file-import"
          [disabled]="!canConfirm() || filling()"
          [loading]="filling()"
          (onClick)="onConfirm()"
          data-testid="template-fill-confirm"
        />
      </div>
    </div>
  }
</p-dialog>
